import { expValEquals } from '@atlassian/jira-feature-experiments';
import { useIsProductUsingCcp } from '@atlassian/jira-billing/src/controllers/billing-system/use-is-product-using-ccp.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import {
	CORE_PROJECT,
	SOFTWARE_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';
import { fg } from '@atlassian/jira-feature-gating';

type StorageUsage = {
	attachmentStorageAllowed?: number;
	attachmentStorageIsUnlimited?: boolean;
	attachmentStorageUsed?: number;
};

export const useShouldBlockStorageUploads = (storageUsage?: StorageUsage): boolean => {
	const { data: projectContextData } = useProjectContext();
	const projectType = projectContextData?.projectType;

	// if projectType is undefined we will return early so nullable operator is just for type safety
	const isUsingCcp = useIsProductUsingCcp(projectType ?? SOFTWARE_PROJECT);

	if (!fg('jira-storage-hard-limit-gate')) {
		return false;
	}

	// not jira
	if (projectType !== SOFTWARE_PROJECT && projectType !== CORE_PROJECT) {
		return false;
	}

	// CCP required for direct buy
	if (!isUsingCcp) {
		return false;
	}

	if (!storageUsage) {
		return false;
	}

	const { attachmentStorageAllowed, attachmentStorageIsUnlimited, attachmentStorageUsed } =
		storageUsage;

	if (
		attachmentStorageIsUnlimited === true ||
		attachmentStorageUsed === undefined ||
		attachmentStorageAllowed === undefined
	) {
		return false;
	}

	if (
		attachmentStorageUsed >= attachmentStorageAllowed &&
		expValEquals('jira-storage-hard-limit', 'cohort', 'variation', 'control')
	) {
		return true;
	}

	return false;
};
